<template>
    <div>
        <div v-if="statusText">
            {{statusText}}
        </div>
        <div v-if="!statusText">
            {{ hours }}:{{ minutes }}:{{ seconds }}
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import momentTimezone   from 'moment-timezone'
    momentTimezone.tz.setDefault('America/Sao_Paulo');
    export default {
    props: ['endtime'] ,
      data: function(){
        return{
              timer:"",
              end: "",
              interval: "",
              minutes:"",
              hours:"",
              seconds:"",
              statusText: "",

        };
      },
      mounted(){
        if (!this.endtime){
            this.statusText = "Não liberado";
            return;
        }
        let endDate = moment(this.endtime, "yyyy-MM-DD HH:mm:ss");
        this.end = endDate.toDate().getTime();
        this.timerCount(this.end);
        this.interval = setInterval(() => {
            this.timerCount(this.end);
        }, 1000);
      },
      methods: {
        timerCount: function(end){
            var now = momentTimezone();            
            
            var passTime =  end - now;

            if(passTime <= 0){
                this.statusText = "Não liberado";
                return;
            } else {
                this.statusText = "";
                this.calcTime(passTime);
            }
        },
        calcTime: function(dist){
            this.hours =  Math.floor(dist / (1000 * 60 * 60)); 
            this.minutes = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60));
            this.seconds = Math.floor((dist % (1000 * 60)) / 1000);
            this.hours = ("00" + this.hours).slice(-2);
            this.minutes = ("00" + this.minutes).slice(-2);
            this.seconds = ("00" + this.seconds).slice(-2);
        }
    }
}

</script>

<style lang="scss" scoped>

.timer {
  font-size: 20px;
  color: #fff;
  text-align:center;
  margin-top: 50px;

      .day, .hour, .min, .sec {
        font-size: 30px;
        display: inline-block;
        font-weight: 500;
        text-align: center;
        margin: 0 5px;
        .format {
          font-weight: 300;
          font-size: 14px;
          //@include margin-start(5);
          //display: inline-block;
          opacity: 0.8;
          width: 60px;
        }
      }
      .number{
        background: rgba(51, 51, 51, 0.53);
        padding: 0 5px;
        border-radius: 5px;
        display: inline-block;
        width: 60px;
        text-align: center;
      }
      .status-tag{
        width: 270px;
        margin: 10px auto;
        padding: 8px 0;
        font-weight: 500;
        color: #000;
        text-align: center;
        border-radius: 15px;
        &.upcoming{
          background-color: lightGreen;
        }
        &.running{
          background-color: gold;
        }
        &.expired{
          background-color: silver;
        }
      }
    }
</style>
